import BotList from "./BotList";
import BotFormPage from "./BotFormPage";
import NotFound from "../other/NotFound";
import BotEditor from "./BotEditor";
import BotTest from "./BotTest";
import BotProfilPage from "./BotProfilPage";

const routes = [
    {path : 'company/:company/bots/list', component : () => <BotList/>, isSidebar : true, isPublic : false , permissions:['view_bots']},
    {path : 'company/:company/bot-profiles', component : () => <BotProfilPage/>, isSidebar : true, isPublic : false , permissions:['view_bots']},
    {path : 'company/:company/bots/:bot', component : () => <BotEditor/>, isSidebar : true, isPublic : false , permissions:['update_bot']},
    {path : 'company/:company/bot/create', component: () => <BotFormPage/>, isSidebar : true, isPublic : false , permissions:['create_bot']},
    {path : 'company/:company/bot/update', component: (data,type) => <BotFormPage data={data} type={type}/>, isSidebar : true, isPublic : false , permissions:['update_bot']},
    {path : 'bot/test/:bot', component: () => <BotTest/>, isSidebar : false, isPublic : true},
    {path : '*', component: () => <NotFound/>, isPublic : true, isSidebar : false},
]

export default routes;